import { routePath } from '~/utils/constants';

type TLoginRoute = {
  id?: string;
};

export const loginRoute = ({ id }: TLoginRoute) => {
  const queryParams = new URLSearchParams({
    uuid: id ?? '',
  });
  return `${routePath.login}?${queryParams.toString()}`;
};

export const getParamValue = (params: string) => {
  const paramsPair: { [key: string]: string | undefined } = {};
  params.split('&').forEach(param => {
    paramsPair[`${param.split('=')[0]}`] = param.split('=')[1];
  });
  return paramsPair;
};
